import { css } from '@emotion/react';

const locationItemStyles = {
    container: css({
        width: '100%',
        display: 'flex',
        backgroundColor: '#ffffff',
        justifyContent: 'space-between',
        padding: '10px 0',
        gap: '15px',
        cursor: 'pointer',

        ['&:first-of-type']: {
            borderTop: '1px solid #F8FBFF',
        },
        ['&:not(:last-of-type)']: {
            borderBottom: '1px solid #F8FBFF',
        },
        ['&:last-of-type']: {
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        },
    }),
    infoBlock: css({
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        gap: '3px',
        padding: 0,
    }),
    infoBlockBadges: css({
        display: 'flex',
        gap: '4px',
    }),
    infoAction: css({
        display: 'flex',
        flexDirection: 'column',
        padding: '15px',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),
    powerBadge: css({
        display: 'flex',
        padding: '4px 11px',
        background: '#DAE7FA',
        borderRadius: '3px',
        alignItems: 'center',
        fontStyle: 'normal',
        fontWeight: 800,
        fontSize: '12px',
        lineHeight: '10px',
        color: '#000000',
    }),
    freeBadge: css({
        display: 'flex',
        padding: '3px 8px',
        background: '#3CBC00',
        borderRadius: '3px',
        alignItems: 'center',
        fontStyle: 'normal',
        fontWeight: 800,
        fontSize: '12px',
        lineHeight: '10px',
        color: '#ffffff',
        textTransform: 'uppercase',
    }),
    connectorsBadge: css({
        display: 'flex',
        padding: '3px 8px',
        gap: '5px',
        background: '#0057B7',
        borderRadius: '3px',
        alignItems: 'center',
        fontStyle: 'normal',
        fontWeight: 800,
        fontSize: '12px',
        lineHeight: '10px',
        color: '#FFFFFF',
    }),
    availableConnectors: css({
        color: '#60E123',
    }),
    title: css({
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '13px',
        lineHeight: '15px',
    }),
    subtitle: css({
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '10px',
        lineHeight: '15px',
    }),
    abbreviation: css({
        fontStyle: 'normal',
        fontWeight: 900,
        fontSize: '16px',
        lineHeight: '18px',
    }),
};

export default locationItemStyles;
